import Footer from "../../shared/Footer"
import ChurchInsuranceHeader from "./ChurchInsuranceHeader"

function ChurchInsurance() {
  return (
    <>
        <ChurchInsuranceHeader />
        <div style={{marginBottom: 34 + 'rem'}} className="py-40 bg-white relative z-10 h-max">
            <div className="mx-3.5 grid grid-cols-1 md:grid-cols-12  mb-10">
                <h2 className="md:col-start-2 md:col-span-10 text-3xl place-self-center text-blue-600 font-semibold mb-10" >church insurance in oklahoma | Harms Insurance Agency, Inc<span className='text-black'>.</span></h2>
            </div>
            <div className="flex items-center mx-80">
            <p className="text-lg">
                Protect your ministry with the expertise of Harms Insurance Agency, Inc., your trusted Oklahoma partner in church insurance. We provide comprehensive, tailored policies for property, liability, workers' compensation, and church auto insurance, understanding the unique challenges and needs of religious organizations. With years of experience serving Oklahoma's faith-based communities, we offer customized solutions and expert guidance. To discuss your specific needs and get a quote, reach out to our dedicated church insurance agent, Chavan Sampley. Ensure your ministry is protected with our personalized service.
            </p>
            </div>
        </div>
        <Footer />
    </>
  )
}

export default ChurchInsurance